<template>
  <div class="d-flex">
    <div class="my-auto">
      <b-input-group
        class="mt-3"
        style="border-radius: 5px; overflow: hidden; min-width: 240px;"
      >
        <b-form-select
          v-model="selectedOrganizationDropdown"
          :options="organizationOptions"
          class="form-control"
        >
          <template #first>
            <b-form-select-option
              :value="null"
              disabled
            >
              Select Area
            </b-form-select-option>
          </template>
        </b-form-select>
        <template #append>
          <router-link
            to="/dashboard"
          >
            <b-button
              variant="white"
              class="h-100 ms-1"
            >
              <i
                class="text-primary mdi mdi-arrow-right"
                style="font-size: 16px"
              />
            </b-button>
          </router-link>
        </template>
      </b-input-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState('organization', ['organizationList', 'selectedOrganization', 'selectedOrganizationDetail']),

    selectedOrganizationDropdown: {
      get() {
        return this.$store.state.organization.selectedOrganization;
      },
      set(value) {
        this.setSelectedOrganization(value);
      },
    },

    organizationOptions() {
      return this.organizationList.map((item) => ({
        text: item.name,
        value: item.id,
      }));
    },
  },

  watch: {
    selectedOrganizationDropdown: {
      immediate: true,
      handler(organizationId) {
        if (organizationId) {
          this.isLoading = true;
          this.getOrganizationDetail(organizationId).then(() => { this.isLoading = false; });
        }
      },
    },

    userOrganizationId: {
      immediate: true,
      handler(organizationId) {
        if (organizationId && !this.selectedOrganization) {
          this.setSelectedOrganization(organizationId);
        }
      },
    },
  },

  mounted() {
    this.$store.dispatch('organization/getOrganizationList');
  },

  methods: {
    ...mapActions('organization', ['getOrganizationDetail']),

    setSelectedOrganization(organizationId) {
      this.$store.commit('organization/SET_SELECTED_ORGANIZATION', organizationId);
      this.getOrganizationDetail(organizationId);
    },

    async getOrganizationDetail(organizationId) {
      try {
        const { data } = await this.$api.getOrganizationDetail(organizationId);
        this.$store.commit('organization/SET_ORGANIZATION_DETAIL', data.data);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.custom-select {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuOTk5NjIgMTAuOTc2N0wxNC4xMjQ2IDYuODUxNjhMMTUuMzAzIDguMDMwMDJMOS45OTk2MiAxMy4zMzM0TDQuNjk2MjkgOC4wMzAwMkw1Ljg3NDYyIDYuODUxNjhMOS45OTk2MiAxMC45NzY3WiIgZmlsbD0iIzA3M0M2NCIvPgo8L3N2Zz4K);
    background-position : 95% 50%;
    background-repeat   : no-repeat;
}
</style>
